import { HeaderCellProps } from '../../types';
import { Tooltip } from '@mui/material';

const DaysHeaderCell = ({ _customRowProps: { day } }: HeaderCellProps) => {
  return (
    <Tooltip title="Total pending entities in the selected number of days">
      <div>Last {day} Days</div>
    </Tooltip>
  );
};

export default DaysHeaderCell;
